import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function BrandColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;
  const validValue = value.includes(';') ? 'Multiple' : value;
  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{validValue}</Typography>
    </Box>
  );
}
